import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { nullValidation, number, string } from "@altostra/type-validations/lib/primitives";
import { recordExcludingArraysOf } from "@dashboardApi/apis/offerfitShared";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult } from "./types";

const nullableNumber = anyOf(number, nullValidation);

const isPerformanceReportKpiResult = objectOf({
  display_unit: anyOf(string, nullValidation),
  numerator_base: number,
  numerator_comparison: number,
  denominator_base: number,
  denominator_comparison: number,
  value_base: number,
  value_comparison: number,
  uplift: nullableNumber,
  dates: arrayOf(string),
  values_base_rolling_1: arrayOf(number),
  values_base_rolling_7: arrayOf(number),
  values_base_rolling_30: arrayOf(number),
  values_comp_rolling_1: arrayOf(number),
  values_comp_rolling_7: arrayOf(number),
  values_comp_rolling_30: arrayOf(number),
  uplift_rolling_1: arrayOf(nullableNumber),
  uplift_rolling_7: arrayOf(nullableNumber),
  uplift_rolling_30: arrayOf(nullableNumber),
});

const isPerformanceReportKpiError = objectOf({
  code: string,
  message: string,
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult = objectOf({
  kpis: recordExcludingArraysOf(isPerformanceReportKpiResult),
  errors: recordExcludingArraysOf(isPerformanceReportKpiError),
}) as (value: unknown) => value is GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult;
